import React from "react";
import { useNavigate } from "react-router-dom";
import { Container,Box, Typography, Button ,Grid} from "@mui/material";
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';


const News = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();  // Çeviri fonksiyonunu alıyoruz
const newsData = [
 
  {

    id: 1,
    title: t("news.new1.title"),
    image: "https://www.remora.com.tr/wp-content/uploads/2025/05/1743003962059.jpeg",
    shortDescription:t("news.new1.shortDescription"),
    date : "02-04-2025",
    fullText: t("news.new1.fullText"),
  },
    {
  
      id: 2,
      title: t("news.new2.title"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/resim1.jpg",
      date : "06-09-2022",
      shortDescription: t("news.new2.shortDescription"),
      fullText: t("news.new2.fullText"),
    },
    {
      id: 3,
      title:  t("news.new3.title"),
      image: "https://www.remora.com.tr/wp-content/uploads/2025/05/resim2.jpg",
      date : "20-12-2022",
      shortDescription:  t("news.new3.shortDescription"),
      fullText: t("news.new3.fullText"),
    },
];


  return (
    <Container sx={{ mt: 5, mb: 5 }}>
      <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
      {t('news.newsTitle')} 
      </Typography>

      {newsData.map((news, index) => (
        <motion.div
          key={news.id}
          initial={{ opacity: 0, y: 50 }} // Başlangıç animasyonu
          animate={{ opacity: 1, y: 0 }}   // Animasyon sonrası görünür olma
          transition={{ delay: index * 0.5, duration: 1 }} // Animasyon sırasını ayarlama
        >
          <Grid container sx={{ mb: 5, alignItems: 'center' }} spacing={3}>
            {/* Resim Bölümü */}
            <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Box
                sx={{
                  width: '90%',
                  height: 400, // Sabit yüksekliği ayarladık
                  overflow: 'hidden',
                  borderRadius: 2,
                  boxShadow: 3,
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)', // Hoverda biraz büyüme
                  },
                }}
              >
                {/* Resim yerleştiriyoruz */}
                <img
                  src={news.image}
                  alt={news.title}
                  style={{
                    width: '100%',
                    height: '100%', // Sabit yüksekliği ve genişliği
                    objectFit: 'cover', // Görselin kesilmeden alana sığmasını sağlar
                  }}
                />
              </Box>
            </Grid>

            {/* Metin Bölümü */}
            <Grid item xs={12} md={6} sx={{ padding: 3 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 'bold',
                  color: '#333',
                  mb: 2,
                  textTransform: 'uppercase',
                  fontSize: '1.5rem',
                }}
              >
                {news.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#555',
                  mb: 3,
                  lineHeight: 1.8,
                  fontSize: '1rem',
                }}
              >
                {news.shortDescription}
              </Typography>

              <Button
                onClick={() => navigate(`/haberler/${news.id}`)}
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: '#1976d2',
                  '&:hover': {
                    backgroundColor: '#1565c0',
                    transform: 'scale(1.05)',
                  },
                  padding: '10px 20px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
              >
                 {t('news.button')} 
             
              </Button>
            </Grid>
          </Grid>
        </motion.div>
      ))}

<Box sx={{ mt: 8, textAlign: 'center' }}>
      {/* Başlık */}
      <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: '#1976d2' }}>
      {t('news.text')} 
       
      </Typography>

      {/* Grid ile 3 LinkedIn postu yan yana yerleştir */}
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12} sm={4} md={4}>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7310688492886331393"
            height="399"
            width="100%"
            frameBorder="0"
            allowFullScreen
            title="Gömülü gönderi 1"
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7301891338747146240"
            height="399"
            width="100%"
            frameBorder="0"
            allowFullScreen
            title="Gömülü gönderi 2"
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <iframe
            src="https://www.linkedin.com/embed/feed/update/urn:li:share:7279411513608536065"
            height="399"
            width="100%"
            frameBorder="0"
            allowFullScreen
            title="Gömülü gönderi 3"
          />
        </Grid>
      </Grid>
    </Box>




  
  



    </Container>
  );
};




export default News; 
